declare const __CONFIG__: {
  siteRootUrl: string;
  frontEndUrl: string;
  cloudinaryApi: string;
  umbracoApiUrl: string;
  marketingSiteUrl: string;
  portalApiUrl: string;
  portalSignInUrl: string;
  portalApiLogoutUrl: string;
  portalRefreshTokenApiUrl: string;
  profileApiUrl: string;
  whoAmIUrl: string;
  linkboardApiUrl: string;
  breakdownsApiUrl: string;
  attachmentsApiUrl: string;
  locationsApiUrl: string;
  jobsApiUrl: string;
  facetsApiUrl: string;
  suggestionsApiUrl: string;
  liteAgentApiUrl: string;
  selfTapesApiUrl: string;
  titaniumApiUrl: string;
  searchApi: string;
  searchAndFiltersApiUrl: string;
  gtm: {
    gtmId: string;
    scriptId: string;
    dataLayerName: string;
    previewVariables: string;
    accountTypes: {
      agent: string;
      performer: string;
      castingDirector: string;
    };
  };
  braze: {
    apiKey: string;
    baseUrl: string;
  };
  oidc: {
    authority: string;
    clientId: string;
    scope: string;
  };
  settings: {
    rolesCountTransitionDisabledThreshold: number;
  };
  isDev?: boolean;
  tagmin: {
    loginUrl: string;
  };
  performerApp: {
    id: string;
  };
};

export default {
  ...__CONFIG__,
};
